// extracted by mini-css-extract-plugin
export default {"container":"GoblinBanner_container__dvzVW","close":"GoblinBanner_close__7jUBr"};